import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi } from "./api";

const AuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
    const [user, setUser] = useState(undefined); // undefined=loading, null=signed-out, obj=signed-in
    const [token, setToken] = useState(null);

    const persistToken = (t) => {
        adminApi.setToken(t);
        setToken(t);
    };

    const signOut = useCallback(async () => {
        try { await adminApi.logout(); } catch (e) { /* ignore */ }
        persistToken(null);
        setUser(null);
    }, []);

    // try to restore session via refresh cookie — but ONLY when actually on admin paths
    useEffect(() => {
        let mounted = true;
        adminApi.setUnauthorizedHandler(() => {
            if (mounted) {
                persistToken(null);
                setUser(null);
            }
        });
        const onAdmin =
            typeof window !== "undefined" &&
            window.location &&
            window.location.pathname.startsWith("/admin");
        if (!onAdmin) {
            // Not on an admin route — don't probe /refresh; just mark as signed-out.
            setUser(null);
            return () => { mounted = false; };
        }
        (async () => {
            try {
                const data = await adminApi.refresh();
                if (!mounted) return;
                persistToken(data.access_token);
                setUser(data.user);
            } catch (e) {
                if (mounted) {
                    persistToken(null);
                    setUser(null);
                }
            }
        })();
        return () => { mounted = false; };
    }, []);

    const signIn = async (email, password) => {
        const data = await adminApi.login(email, password);
        persistToken(data.access_token);
        setUser(data.user);
        return data.user;
    };

    return (
        <AuthCtx.Provider value={{ user, token, signIn, signOut }}>
            {children}
        </AuthCtx.Provider>
    );
};

export const useAdminAuth = () => useContext(AuthCtx);
